import React from 'react';
import Icon from '../../icons';


const DynamicTable = ({columns, data, footer, rowClassName }) => {
  return (
    <table className="table__grid table__grid__border" width="100%">
      
      <thead className='table__grid__fix-header'>
        <tr>
          {columns.map((col) => (
            <th key={col.key}
            className={
              typeof col.headerClassName === 'function'
                ? col.headerClassName(col)
                : col.headerClassName || ''
            }
            >
              {col.headerRender ? col.headerRender() : col.header}
              {col.showFilter && (
                <Icon name="Sortuparrow" className="icon strokeNone" onClick={col.onFilterClick} />
              )}
            </th>
          ))}
        </tr>
      </thead>

      <tbody className=''>
        {data.map((row, index) => (
          <tr
              key={row.id || row.code || index}
              className={rowClassName ? rowClassName(row, index) : ''}
            >
            {columns.map((col) => (
              <td
                key={col.key}
                className={typeof col.className === 'function' 
                  ? col.className(row) 
                  : col.className || ''}
              >
                {col.render ? col.render(row) : row[col.key]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>

      {/* ✅ Footer support */}
      {footer && (
        <tfoot className=''>
          {footer}
        </tfoot>
      )}

    </table>
  );
};

export default DynamicTable;
